import React, { ReactNode } from 'react'
import styled from 'styled-components'

type Props = {
  children: ReactNode
  fullWidth?: boolean
}

const Container = styled.table<Props>`
  overflow: hidden;
  border-collapse: collapse;
  border-radius: 10px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #E9EEF5;

  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`

export const TableContainer: React.FC<Props> = ({ children, fullWidth }) => (
  <Container fullWidth={fullWidth}>
    <tbody>
      {children}
    </tbody>
  </Container>
)
